module.exports = __webpack_public_path__ + "img/pin.082da30d.jpg";